export default "__VITE_ASSET__f20e43ec__"